// While the viewer interacts (a swipe, a slide transition) and for 5 s after,
// time sync does not move the shop-window index.

let doingStuffTimer: ReturnType<typeof setTimeout> | null = null;
let doingStuff = 0;

export function setDoingStuffTimeout() {
  clearTimeout(doingStuffTimer ?? undefined);
  doingStuffTimer = setTimeout(() => {
    doingStuffTimer = null;
  }, 5000);
}

export function isDoingStuff() {
  return doingStuff > 0 || doingStuffTimer !== null;
}

export function startDoingStuff() {
  doingStuff++;
}

export function endDoingStuff() {
  doingStuff--;
}
